import { ModalHandler } from "@/app/hooks/useFilePaste";
import { Image, Modal } from "@douyinfe/semi-ui";
import React from "react";
import styles from "./PasteModal.module.scss";
import SemiButton from "@/app/ui/button";
import Locale from "@/app/locales";

export default function PasteModal({
  visible,
  handler,
}: {
  visible: boolean;
  handler: ModalHandler;
}) {
  return (
    <Modal
      title={Locale.chatInput.sendConfirm}
      visible={visible}
      onCancel={handler.handleCancel}
      centered
      maskClosable={false}
      footer={
        <SemiButton onClick={handler.handleOk}>
          {Locale.button.confirm}
        </SemiButton>
      }
    >
      {handler.getFile() && (
        <Image
          className={styles.img}
          src={handler.getFile() as string}
          height={300}
          alt=""
        />
      )}
    </Modal>
  );
}
